import { render, staticRenderFns } from "./PlatPolicyView.vue?vue&type=template&id=7b2fb427&"
import script from "./PlatPolicyView.vue?vue&type=script&lang=ts&"
export * from "./PlatPolicyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports